export const name = '@lifi/widget'
export const version = '4.0.0-beta.20'
